import { Routes } from '@angular/router';
import { countryGuardFn } from '@core/guards/country.guard';

export enum MyProceduresDetailRouteNames {
  PORTUGAL_CYCLE_CHANGE_DETAIL = 'pt-cycle-change-detail',
  POWER_CHANGE_DETAIL = 'power-tariff-change-detail',
  PORTUGAL_POWER_CHANGE_DETAIL = 'pt-power-change-detail',
  PAYMENT_DEFERMENT_DETAIL = 'payment-deferment-detail',
  INVOICE_CONCEPT_DETAIL = 'invoice-concept-detail',
  PORTUGAL_INVOICE_CONCEPT_DETAIL = 'pt-invoice-concept-detail',
  CANCELLATION_DETAIL = 'cancellation-detail',
  PORTUGAL_CANCELLATION_DETAIL = 'pt-cancellation-detail',
  ACCOUNT_CHANGE_DETAIL = 'account-change-detail',
  PORTUGAL_ACCOUNT_CHANGE_DETAIL = 'pt-account-change-detail',
  INVOICE_ADDRESS_CHANGE_DETAIL = 'invoice-address-change-detail',
  PORTUGAL_CHANGE_BILLING_CONTACTS_DETAIL = 'pt-change-billing-contacts-detail',
  CONCEPTS_DISCREPANCY_DETAIL = 'concepts-discrepancy-detail',
  POWER_DISCREPANCY_DETAIL = 'power-discrepancy-detail',
  PORTUGAL_POWER_DISCREPANCY_DETAIL = 'pt-power-discrepancy-detail',
  MEASUREMENT_DISCREPANCY_DETAIL = 'measurement-discrepancy-detail',
  INVOICE_DELAY_DETAIL = 'invoice-delay-detail',
  OUTAGES_FAILURES_DETAIL = 'outages-failures-detail',
  PORTUGAL_OUTAGES_FAILURES_DETAIL = 'pt-outages-failures-detail',
  MEASUREMENT_FILE_INCIDENCE_DETAIL = 'measurement-file-incidence-detail',
  PORTUGAL_MEASUREMENT_FILE_INCIDENCE_DETAIL = 'portugal-measurement-file-incidence-detail',
  SELF_CONSUMPTION_CHANGE_DETAIL = 'self-consumption-change-detail',
  HOLDER_CHANGE_DETAIL = 'holder-change-detail',
  PORTUGAL_HOLDER_CHANGE_DETAIL = 'pt-holder-change-detail',
  PORTUGAL_INVOICE_DELAY_DETAIL = 'pt-invoice-delay-detail',
  PORTUGAL_METER_READING_DETAIL = 'pt-meter-reading-detail',
}

export const MY_PROCEDURES_DETAIL_ROUTES: Routes = [
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_CYCLE_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-cycle-change-detail/portugal-cycle-change-detail.page').then(
        (p) => p.PortugalCycleChangeDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.POWER_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/power-tariff-change-detail/power-tariff-change-detail.page').then(
        (p) => p.PowerTariffChangeDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_POWER_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-power-change-detail/portugal-power-change-detail.page').then(
        (p) => p.PortugalPowerChangeDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.INVOICE_ADDRESS_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/invoice-address-change-detail/invoice-address-change-detail.page').then(
        (p) => p.InvoiceAddressChangeDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PAYMENT_DEFERMENT_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/payment-deferment-detail/payment-deferment-detail.page').then(
        (p) => p.PaymentDefermentDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.INVOICE_CONCEPT_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/invoice-concept-detail/invoice-concept-detail.page').then((p) => p.InvoiceConceptDetailPage),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_INVOICE_CONCEPT_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-invoice-concept/portugal-invoice-concept-detail.page').then(
        (p) => p.PortugalInvoiceConceptDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.POWER_DISCREPANCY_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/power-discrepancy-detail/power-discrepancy-detail.page').then(
        (p) => p.PowerDiscrepancyDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_POWER_DISCREPANCY_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-power-discrepancy-detail/portugal-power-discrepancy-detail.page').then(
        (p) => p.PortugalPowerDiscrepancyDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.OUTAGES_FAILURES_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/failure-quality-supply-detail/failure-quality-supply-detail.page').then(
        (p) => p.FailureQualitySupplyDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_OUTAGES_FAILURES_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-failure-quality-supply-detail/portugal-failure-quality-supply-detail.page').then(
        (p) => p.PortugalFailureQualitySupplyDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.MEASUREMENT_DISCREPANCY_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/invoice-measurement-discrepancy-detail/invoice-measurement-discrepancy-detail.page').then(
        (p) => p.InvoiceMeasurementDiscrepancyDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.MEASUREMENT_FILE_INCIDENCE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/measurement-file-incidence-detail/measurement-file-incidence-detail.page').then(
        (p) => p.MeasurementFileIncidenceDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_MEASUREMENT_FILE_INCIDENCE_DETAIL,
    loadComponent: () =>
      import(
        '@pages/my-procedures/details/portugal-measurement-file-incidence-detail/portugal-measurement-file-incidence-detail.page'
      ).then((p) => p.PortugalMeasurementFileIncidenceDetailPage),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.CONCEPTS_DISCREPANCY_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/concepts-discrepancy-detail/concepts-discrepancy-detail.page').then(
        (p) => p.ConceptsDiscrepancyDetailPage
      ),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.CANCELLATION_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/cancellation-detail/cancellation-detail.page').then((p) => p.CancellationDetailPage),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_CANCELLATION_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-cancellation-detail/portugal-cancellation-detail.page').then(
        (p) => p.PortugalCancellationDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.SELF_CONSUMPTION_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/self-consumption-detail/self-consumption-detail.page').then((p) => p.SelfConsumptionDetailPage),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.INVOICE_DELAY_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/invoice-delay-detail/invoice-delay-detail.page').then((p) => p.InvoiceDelayDetailPage),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_INVOICE_DELAY_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-invoice-delay-detail/portugal-invoice-delay-detail.page').then(
        (p) => p.PortugalInvoiceDelayDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.ACCOUNT_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/account-change-detail/account-change-detail.page').then((p) => p.AccountChangeDetailPage),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_ACCOUNT_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-account-change-detail/portugal-account-change-detail.page').then(
        (p) => p.PortugalAccountChangeDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.HOLDER_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/holder-change-detail/holder-change-detail.page').then((p) => p.HolderChangeDetailPage),
    canMatch: [countryGuardFn('ES')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_HOLDER_CHANGE_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-holder-change-detail/portugal-holder-change-detail.page').then(
        (p) => p.PortugalHolderChangeDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_CHANGE_BILLING_CONTACTS_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-change-billing-contacts-detail/portugal-change-billing-contacts-detail.page').then(
        (p) => p.PortugalChangeBillingContactsDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
  {
    path: MyProceduresDetailRouteNames.PORTUGAL_METER_READING_DETAIL,
    loadComponent: () =>
      import('@pages/my-procedures/details/portugal-meter-reading-detail/portugal-meter-reading-detail.page').then(
        (p) => p.PortugalMeterReadingDetailPage
      ),
    canMatch: [countryGuardFn('PT')],
    data: {
      breadcrumb: { skip: true },
    },
  },
];
